import React, { useRef, useState } from "react";
import Webcam from "react-webcam";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import "./KycStyles.css";

const videoConstraints = {
  facingMode: { exact: "environment" },
};

export default function IdCapture({ side }) {
  const webcamRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { token } = useParams();
  const [capturing, setCapturing] = useState(false);

  const capture = () => {
    setCapturing(true);
    const imageSrc = webcamRef.current.getScreenshot();
    navigate(`/${token}/id-${side}-confirm`, {
      state: { ...location.state, image: imageSrc },
    });
  };

  const progress = side === "front" ? "50%" : "83%";

  return (
    <div className="kyc-container">
      <div className="kyc-progress">
        <div className="kyc-progress-bar" style={{ width: progress }} />
      </div>
      <h2 className="kyc-title">
        {side === "front" ? "Front of ID" : "Back of ID"}
      </h2>
      <p className="kyc-desc">
        Align the {side} of your ID card within the frame and tap the button to
        capture.
      </p>
      <div className="kyc-webcam-wrapper">
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          videoConstraints={videoConstraints}
          className="kyc-webcam"
        />
        <div className="kyc-id-frame" />
      </div>
      <button
        className="kyc-capture-btn"
        onClick={capture}
        disabled={capturing}
      >
        {capturing
          ? "Processing..."
          : `Capture ${side === "front" ? "Front" : "Back"}`}
      </button>
    </div>
  );
}
